import type { ReactNode } from 'react'

interface Props {
  clientMeta: string
  rightSlot?: ReactNode
}

export function ProposalHeader({ clientMeta, rightSlot }: Props) {
  return (
    <header className="flex items-center justify-between mb-3">
      <p className="text-xs text-muted-foreground">{clientMeta}</p>
      <div className="min-h-[18px]">{rightSlot}</div>
    </header>
  )
}
